function Competitors() {
  return <p>Competitors</p>;
}

export default Competitors;
